import styled from 'styled-components';

import { Box } from '@/components/Box';
import { LegacyButton as BaseButton } from '@/components/LegacyButton';

export const CardContainer = styled(Box)`
  width: 250px;
  max-width: 250px;
  height: 100%;
  overflow: hidden;
`;

export const ValidIcon = styled(Box)<{ isValid?: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin: 5px 4px 8px auto;
  background: ${({ isValid, theme }) =>
    isValid ? theme.colors.valid : theme.colors.error};
`;

export const NameBox = styled(Box)`
  min-height: ${({ theme }) => theme.lineHeights.button};
`;

export const Button = styled(BaseButton)<{ lower?: boolean }>`
  max-width: 170px !important;
`;
